import { useRef, useCallback } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import {
  fetchQuizData,
  rejectSubjectiveAnswerUpload
} from '@actions/quizTaking';
import { getQuizDetails, getLatestSessionUID } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { addTime } from '@utils/dates';
import Timer from './Timer';

const SubmitAnswerTimer = () => {
  const dispatch = useDispatch();
  const { query, reload } = useRouter();
  const { quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));
  const latestSessionUID = useSelectorWithShallowEqual(
    getLatestSessionUID(quizUID)
  );

  const shouldSubmitByRef = useRef(
    addTime(new Date(), quizDetails.latest_session.upload_time_remaining, 'm')
  );

  const handleOnSubmitExpire = useCallback(() => {
    dispatch(rejectSubjectiveAnswerUpload(quizUID, latestSessionUID)).then(
      (resp) => {
        if (resp.error) {
          reload();
        } else {
          dispatch(fetchQuizData(quizUID));
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestSessionUID]);

  return (
    <Timer
      label="SUBMIT ANSWERS IN"
      timestamp={shouldSubmitByRef.current.getTime()}
      onExpire={handleOnSubmitExpire}
    />
  );
};

export default SubmitAnswerTimer;
